import { v4 as uuidv4 } from "uuid"

import type { CalculatorEquation } from "../../types/generated/api/CalculatorEquation"

export const EMPTY_EQUATION = { equation: "", computed_feature_name: "", feature_nesting_separator: "." }

export const FORMIK_INITIAL_VALUES = {
  uuid: uuidv4(),
  name: "",
  equations: [{ uuid: uuidv4(), ...EMPTY_EQUATION, order: 1 }] as Array<CalculatorEquation & { uuid: string }>,
}
